<template>
  <div>
    <FavouritesTable
      :results="favouriteAddresses.results"
      :totalFavourites="favouriteAddresses.total"
      :maxPerPage="favouriteAddresses.maxPerPage"
      :isLoading="loading"
      @callLoadData="loadData"
      @addFavourite="addFavourite"
    />

    <dialog-wrapper ref="addDialog" :width="500">
      <template v-slot:dialogContent>
        <add-favourite-form @addFavourite="closeFavouriteForm()" @cancel="$refs.addDialog.close()" />
      </template>
    </dialog-wrapper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddFavouriteForm from '@/components/favourites/AddFavouriteForm.vue';
import FavouritesTable from '@/components/favourites/FavouritesTable.vue';
import DialogWrapper from '@/components/elements/DialogWrapper.vue';

export default {
  name: 'favourites-view',
  components: {
    AddFavouriteForm,
    FavouritesTable,
    DialogWrapper,
  },
  data: () => ({
    loading: true,
  }),
  computed: {
    ...mapGetters({
      favouriteAddresses: 'favourites/favouriteAddresses',
      getSelectedCorporationId: 'corporations/getSelectedCorporationId',
    }),
  },
  watch: {
    favouriteAddresses() {
      // this.loading = false;
    },
  },
  methods: {
    async loadData(options) {
      this.loading = true;
      await this.$store.dispatch('favourites/getFavouriteAddresses', options);
    },
    addFavourite(options) {
      this.$refs.addDialog.openDialog(options);
    },
    closeFavouriteForm() {
      const options = {
        payload: { page: 0, maxPerPage: 10 },
        businessAccountId: this.getSelectedCorporationId,
      };

      this.$refs.addDialog.close();
      this.loadData(options);
    },
  },
};
</script>
